export default __webpack_public_path__ + "static/media/cn.ded8d79d.svg";